export class DateOnly {
	public readonly year: number;
	public readonly monthIndex: number;
	public readonly day: number;

	public get month(): number {
		return this.monthIndex + 1;
	}

	constructor(year: number, monthIndex: number, day: number) {
		this.year = year;
		this.monthIndex = monthIndex;
		this.day = day;
	}

	public isEqualTo(other: DateOnly): boolean {
		return this.year === other.year
			&& this.monthIndex === other.monthIndex
			&& this.day === other.day;
	}

	public toISOString(): string {
		let formattedMonth: string = `${this.monthIndex + 1}`;
		if (formattedMonth.length === 1) {
			formattedMonth = `0${formattedMonth}`;
		}

		let formattedDate: string = `${this.day}`;

		if (formattedDate.length === 1) {
			formattedDate = `0${formattedDate}`;
		}

		return `${this.year}-${formattedMonth}-${formattedDate}`;
	}

	public toString(): string {
		return this.toISOString();
	}

	public isInvalid(): boolean {
		return isNaN(this.year)
			&& isNaN(this.monthIndex)
			&& isNaN(this.day);
	}

	public static readonly InvalidValue: DateOnly = new DateOnly(NaN, NaN, NaN);
}
